/** Middle/platform: auxiliary core is already gone (document transition, removeCore, 4004). */
export function isPlatformCoreNullError(error: unknown): boolean {
  const err = error as {
    code?: unknown
    developerMessage?: unknown
    response?: { data?: { code?: unknown; message?: unknown; developerMessage?: unknown } }
    message?: unknown
  }
  const code = Number(err?.code ?? err?.response?.data?.code)
  if (code === 4004) return true
  const text = [
    err?.response?.data?.message,
    err?.response?.data?.developerMessage,
    err?.developerMessage,
    err?.message,
  ]
    .filter((part) => part != null && part !== '')
    .join(' ')
    .toLowerCase()
  return (
    text.includes('core is null') ||
    text.includes('core cannot be null') ||
    /"core"\s+is\s+null/.test(text) ||
    text.includes('unable to retrieve core') ||
    text.includes('невозможно получить core')
  )
}

function readRequestRecord(body: unknown): Record<string, unknown> | null {
  if (body && typeof body === 'object' && !Array.isArray(body)) {
    return body as Record<string, unknown>
  }
  if (typeof body !== 'string' || body.trim() === '') return null
  try {
    const parsed = JSON.parse(body) as unknown
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return parsed as Record<string, unknown>
    }
  } catch {
    return null
  }
  return null
}

/**
 * Listener reload and submit=auto STACK hit a core the server already dropped.
 * That is not a user action failure: no toast. A clicked platform action still reports 4004.
 */
export function isBenignMissingPlatformCoreRequest(
  url: unknown,
  body: unknown,
  error: unknown,
): boolean {
  if (!isPlatformCoreNullError(error)) return false
  const path = String(url ?? '')
  if (
    path.includes('/platform/reload/panel') ||
    path.includes('/platform/reload/form') ||
    path.includes('/platform/reload/element')
  ) {
    return true
  }
  if (!path.includes('/platform/action')) return false
  const record = readRequestRecord(body)
  return Number(record?.actionType) === 2 && Number(record?.actionId) === -1
}